import { ElementConfigType } from '@/pages2/DetailedDescription/store/type';
import React, { useCallback, useEffect } from 'react';
import { useDrop } from 'react-dnd';
import { ComponentIdEnum } from '../component-factory/ComponentIdEnum';
import { DndTypes as ItemTypes } from '../editor/DndTypes';

export const useBasicDrop = ({ nodeId, componentId }: ElementConfigType) => {
  const [currentStyle, setCurrentStyle] = React.useState<any>({});

  const judgeSlotPos = useCallback(() => {
    switch (componentId) {
      case ComponentIdEnum.COLUMNS_CONTAINER_COMPONENT:
        return {
          background: '#eee',
          borderRight: '8px solid #f8c000',
        };
      case ComponentIdEnum.ROWS_CONTAINER_COMPONENT:
        return {
          background: '#eee',
          borderBottom: '8px solid #f8c000',
        };
      default:
        return {
          background: '#eee',
          borderBottom: '8px solid #f8c000',
        };
    }
  }, [componentId]);

  const getStyle = useCallback(
    (isOverCurrent: boolean, canDrop: boolean) => {
      if (isOverCurrent) {
        return judgeSlotPos();
      } else if (canDrop) {
        return {
          background: '#eee',
        };
      } else {
        return {};
      }
    },
    [judgeSlotPos],
  );

  const [{ isOverCurrent, canDrop }, drop] = useDrop(
    () => ({
      accept: ItemTypes.BOX,
      drop(_item, monitor) {
        const didDrop = monitor.didDrop();
        if (didDrop) {
          return;
        }
        return {
          droppableId: nodeId,
          allowedDropEffect: nodeId,
        };
      },
      collect: (monitor) => ({
        isOverCurrent: monitor.isOver({ shallow: true }),
        canDrop: monitor.canDrop(),
      }),
    }),
    [],
  );

  useEffect(() => {
    setCurrentStyle(getStyle(isOverCurrent, canDrop));
  }, [canDrop, getStyle, isOverCurrent]);

  return {
    drop,
    currentStyle,
  };
};
